import React from "react";
import BaseListPage from "../../base/BaseListPage";
import withRouter from "../../withRouter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import NavBar from "../../components/navbar";
import schemaDashboard from "./schemaDashboard.json";
import Count from "../dashboard/components/Count";
import ProductsPresenter from "./ProductsPresenter";
import TopItemRevenuePage from "./chart/top-item-revenue/TopItemRevenuePage";
import TopItemQuantityPage from "./chart/top-item-quantity/TopItemQuantityPage";
import BottomItemRevenuePage from "./chart/bottom-item-revenue/BottomItemRevenuePage";
import BottomItemQuantityPage from "./chart/buttom-item-quantity/ButtomItemQuantityPage";
import DateRangeReport from "../../components/DateRangeReport";
import DefaultState from "../sales-and-transactions/components/DefaultState";
import Select from "react-select";
import {
  printChart,
  exportToCSV as exportToCSVUtil,
  getChartDataTopRevenue,
  getChartDataBottomRevenue,
  getChartDataTopQuantity,
  getChartDataBottomQuantity,
  formatSales,
} from "./utils/productHelper";
import {
  calculateFreeItemsBySKUAsync,
  calculateTotalQuantityByItemAsync,
  calculateTotalSalesByItemAsync,
} from "./utils/aggregateHelper";
import Search from "../../components/Search";

class ProductsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.presenter = new ProductsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      where: {},
      range: "",
      itemDataRevenue: {},
      itemDataQuantity: {},
      itemDataQuantityFree: {},
      storess: "",
      store: [],
      printThisData: [],
      notFound: false,
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    if (this.state.objects.length > 0) {
      this.calculateTotalSalesByItem();
      this.calculateTotalQuantityByItem();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.objects.length > 0 &&
      prevState.objects !== this.state.objects
    ) {
      this.calculateTotalSalesByItem();
      this.calculateTotalQuantityByItem();
    }
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
  }

  onChangeStore(where) {
    // this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  searchButton() {
    this.setState({ storess: "All" });
    this.presenter.searchButton();
  }

  searchSubmit(where, merge) {
    this.presenter.searchSubmit(where, merge);
  }

  getValueForDashboardObject(object) {
    switch (object.label) {
      // case "Gross Sales":
      //   return this.presenter.calculateGrossSalesInfo();
      case "Total Item Sold":
        return this.presenter.calculateTotalItemSoldSalesInfo();
      case "Total Transaction":
        return this.presenter.calculateTotalTransactionInfo();
      case "Total Guest":
        return this.presenter.calculateTotalGuestInfo();
      case "Discount Cost":
        return this.presenter.calculateDiscountCost();
      default:
        return { value: 0, percentage: 0 };
    }
  }

  async calculateTotalSalesByItem() {
    const totalSalesByItem = await calculateTotalSalesByItemAsync(
      this.state.objects,
      { onlyCodes: ["00161"], log: true }
    );
    console.log("ibig", totalSalesByItem);
    const totalQuantityFree = await calculateFreeItemsBySKUAsync(
      this.state.objects
    );

    this.setState({ itemDataRevenue: totalSalesByItem });
    this.setState({ itemDataQuantityFree: totalQuantityFree });
  }

  async calculateTotalQuantityByItem() {
    const totalQuantityByItem = await calculateTotalQuantityByItemAsync(
      this.state.objects
    );
    this.setState({ itemDataQuantity: totalQuantityByItem });
  }

  exportToCSV = (datasetType, isTop = true, numberOfItems = 1000) => {
    const {
      storess,
      range,
      itemDataRevenue,
      itemDataQuantity,
      itemDataQuantityFree,
    } = this.state;

    exportToCSVUtil(
      datasetType,
      isTop,
      numberOfItems,
      storess,
      range,
      itemDataRevenue,
      itemDataQuantity,
      itemDataQuantityFree
    );
    // let dataset = [];
    // let fileNameSuffix = "";
    // let title = ""; // Initialize title variable

    // switch (datasetType) {
    //   case "revenue":
    //     dataset = Object.entries(itemDataRevenue)
    //       .sort((a, b) =>
    //         isTop ? b[1].sales - a[1].sales : a[1].sales - b[1].sales
    //       )
    //       .slice(0, numberOfItems)
    //       .map((data) => ({
    //         Store: storess,
    //         Date: `${range.tran_date["$gte"].split("T")[0]} - ${
    //           range.tran_date["$lte"].split("T")[0]
    //         }`,
    //         Item_Name: data[1].description,
    //         Revenue: data[1].sales,
    //         Quantity: data[1].quantity,
    //       }));
    //     fileNameSuffix = isTop ? "top-item-revenue" : "bottom-item-revenue";
    //     title = isTop ? "Top Item Revenue" : "Bottom Item Revenue";
    //     break;
    //   case "quantity":
    //     dataset = Object.entries(itemDataQuantity)
    //       .sort((a, b) =>
    //         isTop
    //           ? b[1].quantity - a[1].quantity
    //           : a[1].quantity - b[1].quantity
    //       )
    //       .slice(0, numberOfItems)
    //       .map((data) => ({
    //         Store: storess,
    //         Date: `${range.tran_date["$gte"].split("T")[0]} - ${
    //           range.tran_date["$lte"].split("T")[0]
    //         }`,
    //         Item_Name: data[1].description,
    //         Quantity: data[1].quantity,
    //         Revenue: data[1].sales,
    //       }));
    //     fileNameSuffix = isTop ? "top-item-quantity" : "bottom-item-quantity";
    //     title = isTop ? "Top Item Quantity" : "Bottom Item Quantity";
    //     break;
    //   default:
    //     console.error("Invalid dataset type");
    //     return;
    // }

    // const csvString = this.convertToCSV(dataset, title); // Pass title to convertToCSV
    // const a = document.createElement("a");
    // const blob = new Blob([csvString], { type: "text/csv" });
    // const url = window.URL.createObjectURL(blob);
    // const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${
    //   range.tran_date["$lte"].split("T")[0]
    // }`;

    // a.href = url;
    // a.download = `${storess}-${dateRange}-${fileNameSuffix}.csv`;
    // a.click();
    // window.URL.revokeObjectURL(url);
  };

  convertToCSV = (arr, title = "") => {
    // Include the title in the CSV string if provided
    let csvContent = title ? `${title}\n` : "";
    // Add the header row
    csvContent += Object.keys(arr[0]).join(",") + "\n";
    // Add the data rows
    arr.forEach((item) => {
      csvContent += Object.values(item).join(",") + "\n";
    });
    return csvContent;
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { itemDataRevenue, itemDataQuantity, range, storess } = this.state;
    const objects = this.state?.objects?.filter((obj) => obj.status === "C");
    console.log("Transactions:", objects);
    // console.log("OBJECTS:", this.state.objects);
    const chartDataTopRevenue = getChartDataTopRevenue(itemDataRevenue);
    const chartDataBottomRevenue = getChartDataBottomRevenue(itemDataRevenue);
    const chartDataTopQuantity = getChartDataTopQuantity(itemDataQuantity);
    const chartDataBottomQuantity =
      getChartDataBottomQuantity(itemDataQuantity);
    console.log("this.state.notFound", this.state.notFound);

    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center">
              <h1
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#83c14a" }}
              >
                Products Analytics
              </h1>
            </div>
            <div className="row mb-2 ">
              <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
                <DateRangeReport
                  onChange={this.onChangeDate.bind(this)}
                  field="tran_date"
                />
              </div>

              <div className="col-sm-3">
                <Select
                  options={[
                    { value: "AllStore", label: "All Store" },
                    ...this.state.store.map((code) => ({
                      value: code.name,
                      label: code.name,
                    })),
                  ]}
                  onChange={(selectedOption) =>
                    this.onChangeStore(selectedOption?.value)
                  }
                  isDisabled={!this.state.range}
                />
              </div>
              <div className="col-sm-3">
                <Search
                  schemas={this.getSchemas()}
                  className=""
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </div>
              <div className="col-sm-2">
                {" "}
                <button
                  className="btn btn-success text-white"
                  onClick={this.searchButton.bind(this)}
                >
                  Search
                </button>
              </div>
            </div>
            {this.state.objects?.length > 0 ? (
              <>
                <div className="row mt-1 g-3">
                  {schemaDashboard.map((object, index) => {
                    const { value, percentage } =
                      this.getValueForDashboardObject(object, objects);
                    const navigationTarget = object.navigationTarget;
                    return (
                      <div key={index} className="col-6 col-md-3">
                        <Count
                          collection={object.collection}
                          icon={object.icon}
                          where={object.where}
                          val={value}
                          label={object.label}
                          labelAction={object.labelAction}
                          barangayValue={this.state.barangayValue}
                          object={object}
                          percentage={percentage}
                          bg={object.bg}
                        />
                      </div>
                    );
                  })}
                </div>

                {this.state.count > 0 &&
                  this.state.objects.length < this.state.count && (
                    <div className="w-100 mb-2 mt-4">
                      <div className="progress" style={{ height: "10px" }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                          role="progressbar"
                          style={{ width: `${this.getProgressPercentage()}%` }}
                          aria-valuenow={this.getProgressPercentage()}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        />
                      </div>
                      <small className="text-muted">
                        Loading data... {this.state.objects.length} of{" "}
                        {this.state.count}
                      </small>
                    </div>
                  )}

                <TopItemRevenuePage
                  objects={objects}
                  itemDataRevenue={itemDataRevenue}
                  range={range}
                  storess={storess}
                  chartDataTopRevenue={chartDataTopRevenue}
                  printChart={printChart}
                  exportToCSV={this.exportToCSV}
                  formatSales={formatSales}
                />
                <BottomItemRevenuePage
                  objects={objects}
                  itemDataRevenue={itemDataRevenue}
                  range={range}
                  storess={storess}
                  chartDataBottomRevenue={chartDataBottomRevenue}
                  printChart={printChart}
                  exportToCSV={this.exportToCSV}
                  formatSales={formatSales}
                />
                <TopItemQuantityPage
                  objects={objects}
                  itemDataQuantity={itemDataQuantity}
                  range={range}
                  storess={storess}
                  chartDataTopQuantity={chartDataTopQuantity}
                  printChart={printChart}
                  exportToCSV={this.exportToCSV}
                  formatSales={formatSales}
                />
                <BottomItemQuantityPage
                  objects={objects}
                  itemDataQuantity={itemDataQuantity}
                  range={range}
                  storess={storess}
                  getChartOptionsBottomQuantity={chartDataBottomQuantity}
                  printChart={printChart}
                  exportToCSV={this.exportToCSV}
                  formatSales={formatSales}
                />
              </>
            ) : !this.state.range || !this.state.storess ? (
              <div className="text-center align-items-center mt-4">
                <img
                  src="./choosefirst.png"
                  style={{ height: "200px", width: "200px" }}
                />
                <h4 className="mt-4 fw-semibold text-muted text-center">
                  👋 To get started, please select a{" "}
                  <span className="text-success">date range</span> and{" "}
                  <span className="text-success">store</span> above.
                </h4>
              </div>
            ) : this.state.notFound ? (
              <div className="text-center mt-5">
                <p className="text-muted fs-5">
                  📭 Data not found for selected filter.
                </p>
              </div>
            ) : (
              <div className="text-center mt-5">
                <DefaultState />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ProductsPage);
